<template>
    <div class="company-create">
        <data-form title="Add Company"
                   tag="company-create"
                   save-button-label="Submit"
                   :field-model="company"
                   :field-groups="fieldGroups"
                   :on-submit-handler="onSubmit"
                   cancelRoute="/company/list"
                   submit-success-message="Company created"
                   submit-error-message="Error creating company">
        </data-form>
    </div>
</template>

<script>
import Vue from 'vue'
import Company from '@/models/Company'

export default Vue.extend({
    name: 'CompanyCreate',
    data () {
        return {
            company: Company,
            fieldGroups: [
                ['id', 'name', 'ccb_number', 'alt_license', 'alt_license_type', 'alt_license_number', 'url', 'cobid_certified', 'cobid_number', 'cobid_types'],
                ['mailing_address', 'city', 'state', 'zip'],
            ],
        }
    },
    methods: {
        onSubmit (modelInstance) {
            return this.$api.createItem(this, 'company', modelInstance)
                .then((response) => {
                    if (response.body.id) {
                        this.$router.push(`/company/view/${response.body.id}`)
                    }
                })
        }
    }
})
</script>
